//React
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Form } from 'react-bootstrap';
//API
import { TemplateApi } from '../../apis/index';
//Material-UI
import Grid from '@material-ui/core/Grid';
import AutoComplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
//Components
import BasicModal from '../../components/Modal.js';
import MyLoading from '../../components/Loading.js';

export const styled = {
  titleText: {
    textIndent: '5px',
    paddingBottom: '3px',
    margin: '0',
    color: '#3F598C',
    fontWeight: 'bold',
  },
  largeBox: {
    border: '1px solid #3F598C',
    padding: '10px 0px',
    marginBottom: '20px',
    borderRadius: '5px',
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 350px))',
    gridGap: '20px',
    justifyContent: 'center',
  },
  smallBox: {
    display: 'flex',
    justifyContent: 'space-between',
    border: '1px solid #D9D9D9',
    width: '350px',
    borderRadius: '5px',
    padding: '5px 10px',
    alignItems: 'center',
  },
  inputText: {
    width: '250px',
    height: '35px',
    wordBreak: 'break-word',
    fontSize: '12px',
    padding: '0',
    display: 'flex',
    alignItems: 'center',
  },
  inputBox: {
    border: 'none',
    backgroundColor: '#D9D9D9',
    borderRadius: '5px',
    textAlign: 'center',
    width: '70px',
    height: '25px',
    fontSize: '12px',
  },
  memo: {
    border: '1px solid #3F598C',
    padding: '10px',
    marginBottom: '20px',
    borderRadius: '5px',
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    resize: 'none',
  },
};

const TemplateSave = (props) => {
  const [template, setTemplate] = useState([]);
  const [templateList, setTemplateList] = useState([]);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const templateKey = ['scaffoldProperty', 'scaffoldMaterial', 'kitInfo'];

  const [loading, setLoading] = useState(false);

  //템플릿 이름 중복일 경우 템플릿 이름으로 Focus
  const inputRef = useRef(null);

  useEffect(() => {
    getTemplateInfo();
    getTemplateList();
  }, []);

  const getTemplateInfo = async () => {
    const res = await TemplateApi.getTemplateInfo();
    setTemplate(res.data);
  };
  const getTemplateList = async () => {
    const res = await TemplateApi.getTemplate();
    setTemplateList(res.data);
  };

  const selectOldTemplate = async (e, value) => {
    if (value.label.toString().trim().length === 0) {
      return;
    }
    const res = await TemplateApi.getTemplateByName(value.id);
    setTemplate({
      ...template,
      scaffoldProperty: res.data.scaffoldProperty,
      kitInfo: res.data.kitInfo,
      scaffoldMaterial: res.data.scaffoldMaterial,
    });
  };

  const templateName = useMemo(() => {
    return templateList.map((template) => {
      return { label: template.templateName, id: template.id };
    });
  }, [templateList]);

  const changeTitleorMemo = (e) => {
    setTemplate({
      ...template,
      [e.target.name]: e.target.value,
    });
  };

  const changeValue = (e) => {
    const firstValue = e.target.name.split('.');
    if (firstValue[1] === 'version' || firstValue[1] === 'invivoSpec') {
      setTemplate((prev) => ({
        ...prev,
        [firstValue[0]]: {
          ...prev[firstValue[0]],
          [firstValue[1]]: e.target.value,
        },
      }));
    } else if (
      /^(-?\d+\.\d*|-?\d*|-)$/.test(e.target.value) ||
      e.target.value === ''
    ) {
      setTemplate((prev) => ({
        ...prev,
        [firstValue[0]]: {
          ...prev[firstValue[0]],
          [firstValue[1]]: e.target.value,
        },
      }));
    }
  };

  const saveTemplate = async (e) => {
    e.preventDefault();
    if (
      template.templateName === null ||
      template.templateName.trim().toString().length === 0
    ) {
      inputRef.current.focus();
      showModalWithContent('템플릿 이름이 없습니다.');
      handleModalOpen();
      return;
    }
    //TODO 템플릿 이름에 특수문자 제거 후 이름 저장(버그 아님 의도되어 있음 ㅋ)
    let reg = /[`ㅤ~!@#$%^&*()|+\=?;:'"<>\{\}\[\]\\\/ ]/gim;
    const templateTrimName = template.templateName.replace(reg, '');
    setTemplate({
      ...template,
      templateName: templateTrimName,
    });
    setLoading(true);
    const res = await TemplateApi.saveTemplate({
      ...template,
      templateName: templateTrimName,
    });
    //템플릿 등록 성공
    if (res.statusCode === 200) {
      props.history.push('/template');
    } else {
      setLoading(false);
      alert(res.statusCode + '\n' + res.message);
    }
  };

  //Modal
  const handleModalOpen = () => {
    setModalStatus(true);
  };

  const handleModalClose = () => setModalStatus(false);

  const showModalWithContent = (content) => {
    setModalContent(content);
  };

  useEffect(() => {
    if (modalContent) {
      setModalStatus(true);
    }
  }, [modalContent]);
  //
  return (
    <div>
      <style>
        {/* Focus */}
        {`
          textarea:focus {
            outline: none;
          }
          input:focus {
            outline: none;
          }
        `}
      </style>
      <Form onSubmit={saveTemplate} onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}>
        <Form.Group style={{ marginBottom: '30px' }}>
          <Form.Label>Template Name</Form.Label>
          <Form.Control
            ref={inputRef}
            type="text"
            placeholder="Template Name"
            onChange={changeTitleorMemo}
            name="templateName"
            required
            autoComplete="off"
            maxLength={50}
          />
        </Form.Group>

        <Form.Group>
          <AutoComplete
            disablePortal
            options={templateName}
            onChange={selectOldTemplate}
            sx={{ width: '100%' }}
            renderInput={(params) => (
              <TextField {...params} label="Copy Template" />
            )}
          />
        </Form.Group>
        <Form.Group>
          {templateKey.map((property, index) => {
            return (
              <div>
                {template[property] ? (
                  <div>
                    <p style={styled.titleText}>{property}</p>
                    <div style={styled.largeBox}>
                      {Object.entries(template[property]).map(
                        ([key, value]) => {
                          return (
                            <div style={styled.smallBox}>
                              <div style={styled.inputText}>
                                <div>{key}</div>
                              </div>
                              <input
                                style={styled.inputBox}
                                value={value}
                                name={property + '.' + key}
                                onChange={changeValue}
                                autoComplete="off"
                                maxLength={9}
                                required
                              />
                            </div>
                          );
                        },
                      )}
                    </div>
                  </div>
                ) : (
                  <div
                    style={{
                      ...styled.largeBox,
                      display: 'flex',
                      padding: '30px 0px',
                    }}
                  >
                    <CircularProgress />
                  </div>
                )}
              </div>
            );
          })}
        </Form.Group>
        <Form.Group>
          <Form.Label style={styled.titleText}>Memo</Form.Label>
          <textarea
            name="memo"
            style={styled.memo}
            value={template.memo}
            onChange={changeTitleorMemo}
          ></textarea>
        </Form.Group>
        <Grid container direction="row" justifyContent="center">
          <button
            type="button"
            className="red"
            style={{ marginRight: '25px' }}
            onClick={() => {
              props.history.goBack();
            }}
          >
            Back
          </button>
          <button className="blue" style={{ marginLeft: '25px' }} type="submit">
            Save
          </button>
        </Grid>
      </Form>
      <div style={{ display: 'none' }}>
        <BasicModal
          open={modalStatus}
          handleModalClose={handleModalClose}
          content={modalContent}
        />
      </div>
      {loading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <MyLoading />
        </div>
      )}
    </div>
  );
};

export default TemplateSave;
